import { useRepositorySuspenseQuery, ExportTypeEnum } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useExportDetails = (exportId: string, exportType: ExportTypeEnum) => {
    const enterpriseId = useCurrentEnterpriseId();

    return useRepositorySuspenseQuery('exports', 'details', {
        enterpriseId,
        exportId,
        exportType,
    });
};
